/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from 'axios'
import router from '@/router'
import { baseApiUrl } from '../../global'
export default {



  async fetchEquipmentReviewOrder({ commit }, payload) {
    
    
    try {
      payload.loading()
      const response = await axios.get(
        `${baseApiUrl}/equipmentReviewOrder/getEquipmentReviewOrder?type=${payload.type}`
      )
      payload.loading.close()
      commit('SET_EQUIPMENT_REVIEW_ORDER', response.data)
    } catch (error) {
      console.log(error)
    }
  },


  async addNewEquipmentReviewOrder({ commit }, payload) {
 
    try {
      payload.loading()
      let res = await axios.post(`${baseApiUrl}/equipmentReviewOrder/save`, payload.order)
      payload.order.idEquipmentReviewOrder = res.data
      delete payload.order.itemsOrder
      commit('ADD_NEW_EQUIPMENT_REVIEW_ORDER', payload.order)
      payload.loading.close()
      payload.notify({
        title: "Salvo",
        text: "com Sucesso",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "success"
      })
    } catch (error) {
      console.log(error)
      payload.notify({
        title: "Erro",
        text: "Não foi possivel salvar " + error,
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger"
      })
    }
    router.push(`/revisao-equipamentos`).catch(() => { });
  },



  async removeEquipmentReviewOrder({ commit }, payload) {
    let idEquipmentReviewOrder = payload.idOrder
    try {
      payload.loading()
      await axios.post(`${baseApiUrl}/equipmentReviewOrder/remove`, { idEquipmentReviewOrder })
      payload.loading.close()
      commit('REMOVE_EQUIPMENT_REVIEW_ORDER', idEquipmentReviewOrder)
      payload.notify({
        title: "Removido",
        text: "com Sucesso",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "success"
      })
    } catch (error) {
      console.log(error)
      payload.notify({
        title: "Erro",
        text: "Não foi possivel apagar " + error,
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger"
      })
    }

  },


  async updateEquipmentReviewOrder({ commit }, payload) {

    try {
      payload.loading()
      await axios.post(`${baseApiUrl}/equipmentReviewOrder/update`, payload.order)
      delete payload.order.itemsOrder
      commit('UPDATE_EQUIPMENT_REVIEW_ORDER', payload.order)
      payload.loading.close()
      payload.notify({
        title: "Atualizado",
        text: "com Sucesso",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "primary"
      })
    } catch (error) {
      //console.log(error)
      payload.notify({
        title: "Erro",
        text: "Não foi possivel salvar " + error,
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger"
      })
    }
    router.push(`/revisao-equipamentos`).catch(err => { });
  },
 
  async trashEquipmentReviewOrder({ commit }, payload) {
    let idEquipmentReviewOrder = payload.idOrder
    
    try {
      payload.loading() 
      await axios.post(
        `${baseApiUrl}/equipmentReviewOrder/trash`,{ idEquipmentReviewOrder }
      )
      payload.loading.close()
      commit('REMOVE_EQUIPMENT_REVIEW_ORDER', idEquipmentReviewOrder)
      payload.notify({
        title: "Removido",
        text: "com Sucesso",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "success"
      })
    } catch (error) {
      console.log(error)
      payload.notify({
        title: "Erro",
        text: "Não foi possivel apagar " + error,
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger"
      })
    }
  },
}
